import { Button, Modal } from "antd";
import React, { useState, useEffect, useRef } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import FormInput from "./FormInput";

const DEFAULT_CROP = { aspect: 3 / 4 };

const ProductUploadWithCrop = ({ form, image = null, name }) => {
  const defaultAspect = DEFAULT_CROP.aspect;
  const fileInputRef = useRef(null);
  const cropperRef = useRef(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [croppedImage, setCroppedImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    if (image) {
      setImageFile(image);
    }
  }, [image]);

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const newImage = event.target.files[0];

      const reader = new FileReader();
      reader.onload = (event) => {
        setImageUrl(event.target.result);
        setIsModalOpen(true);
      };
      reader.readAsDataURL(newImage);
      event.target.value = null;
    }
  };

  const handleCrop = () => {
    const cropper = cropperRef.current.cropper;
    const canvas = cropper.getCroppedCanvas();

    if (canvas) {
      const base64Image = canvas.toDataURL("image/webp");
      console.log(base64Image)
      if (base64Image) {
        form.setFieldsValue({
          items: form.getFieldValue("items")?.map((item, itemIndex) =>
            itemIndex === name[0]
              ? {
                  ...item,
                  media: item?.media?.map((imgObj, imgIndex) =>
                    imgIndex === name[2]
                      ? {
                          ...imgObj,
                          media: base64Image,
                          altText: imgObj?.altText || "",
                        }
                      : imgObj
                  ),
                }
              : item
          ),
        });
        setImageFile(base64Image);
      }
      canvas.toBlob((blob) => {
        if (blob) {
          const webpBlobUrl = URL.createObjectURL(blob);
          setCroppedImage(webpBlobUrl);
        }
      }, "image/webp");
    }
  };

  const handleSubmit = () => {
    setIsModalOpen(false);
    handleCrop();
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    setImageUrl(null);
    setCroppedImage(null);
  };

  useEffect(() => {
    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
      if (croppedImage) {
        URL.revokeObjectURL(croppedImage);
      }
    };
  }, [imageUrl, croppedImage]);

  return (
    <div>
      <input
        ref={fileInputRef}
        accept=".jpeg, .jpg, .png, .webp"
        id="fileInput"
        type="file"
        onChange={handleImageChange}
        style={{ display: "none" }}
      />
      <div className="upload-file">
        <div className="upload-file_heading">
          <h2>Image</h2>
          {imageFile && (
            <Button onClick={() => fileInputRef.current.click()}>Edit</Button>
          )}
        </div>
        {imageFile ? (
          <>
            <div className="upload-file_image">
              <img src={imageFile} alt="cropped-image" />
            </div>
            <FormInput
              label="Image Alt Text"
              name={[name[2], "altText"]}
              // rules={[{ required: true, message: "Please enter title" }]}
              placeholder="Enter image alt text"
            />
          </>
        ) : (
          <div htmlFor="fileInput" className="upload-file_container">
            <Button onClick={() => fileInputRef.current.click()}>
              Add image
            </Button>
            <p>or drop an image to upload</p>
          </div>
        )}
      </div>
      {imageUrl && (
        <Modal
          title="Crop Image"
          open={isModalOpen}
          onCancel={handleModalCancel}
          footer={[
            <Button key="back" onClick={handleModalCancel}>
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={handleSubmit}>
              Submit
            </Button>,
          ]}
        >
          <div className="upload-image">
            <Cropper
              ref={cropperRef}
              src={imageUrl}
              style={{ height: 400, width: "100%" }}
              aspectRatio={defaultAspect}
              guides={true}
              viewMode={1}
              autoCropArea={1}
              zoomable={false}
            />
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ProductUploadWithCrop;
